import {
  APP_ZONES,
  BaseWidgetProperties,
  ButtonActionType,
  GridPosition,
  PermissionConfig,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
  WorkflowWidgetConfigurationAttributes,
} from '@finxone-platform/shared/sys-config-types';
import { FormSubmissionButtonWidgetBuilder } from '../../defaults/widgets';

export const getV1_0_165ToV1_0_166 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.166';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        roles.forEach((item) => {
          const paymentZone = item.zones[APP_ZONES.PAYMENT];
          if (paymentZone) {
            const mobilePages = paymentZone?.canvases?.subscription?.['default']?.mobile?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const desktopPages = paymentZone?.canvases?.subscription?.['default']?.desktop?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const tabletPages = paymentZone?.canvases?.subscription?.['default']?.tablet?.pages as
              | WorkflowPageConfig[]
              | undefined;
            if (mobilePages?.length) {
              findPageAndReplaceWidget(mobilePages);
            }
            if (desktopPages?.length) {
              findPageAndReplaceWidget(desktopPages);
            }
            if (tabletPages?.length) {
              findPageAndReplaceWidget(tabletPages);
            }
          }
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
        };
      },
    },
  };
};

/**
 * Replaces the old MandatoryCTAButton widget with the newer type of action button with its own action.
 */
const findPageAndReplaceWidget = (pagesArray: WorkflowPageConfig[]): WorkflowPageConfig[] => {
  /**
   * Finds a page that has a name that matches one of the SMS pages.
   *
   */
  for (const page of pagesArray) {
    if (page?.name === 'intl-pay-beneficiary') {
      page.widgets = page.widgets.map((widget) => {
        if (widget.name === WidgetNames.MANDATORY_CTA_BUTTON) {
          return new FormSubmissionButtonWidgetBuilder()
            .configDisplayName('Button: Review Payment Details')
            .gridPosition({ y: 22, rows: 2 } as GridPosition)
            .cssConfig({
              paddingTop: 15,
              paddingBottom: 15,
            })
            .attributes({
              widgetProperties: {
                textContent: 'Review Payment Details',
                zoneToNavigate: APP_ZONES.PAYMENT,
                urlToNavigate: 'intl-review-payment-details',
                buttonActionType: ButtonActionType.INTL_TRANSFER_PRECHECK,
              } as BaseWidgetProperties,
            } as WorkflowWidgetConfigurationAttributes)
            .build();
        }
        return widget;
      });
      break;
    }
  }
  return pagesArray;
};
